import { ASC, DEFAULT_ORDER_FIELD, DEFAULT_PAGE_SIZE } from "constants/pagination";
import { LOCALE_PT_BR } from "../constants/date-time";

export const ufs = [
  { value: "AC", label: "Acre" },
  { value: "AL", label: "Alagoas" },
  { value: "AP", label: "Amapá" },
  { value: "AM", label: "Amazonas" },
  { value: "BA", label: "Bahia" },
  { value: "CE", label: "Ceará" },
  { value: "DF", label: "Distrito Federal" },
  { value: "ES", label: "Espírito Santo" },
  { value: "GO", label: "Goiás" },
  { value: "MA", label: "Maranhão" },
  { value: "MT", label: "Mato Grosso" },
  { value: "MS", label: "Mato Grosso do Sul" },
  { value: "MG", label: "Minas Gerais" },
  { value: "PA", label: "Pará" },
  { value: "PB", label: "Paraíba" },
  { value: "PR", label: "Paraná" },
  { value: "PE", label: "Pernambuco" },
  { value: "PI", label: "Piauí" },
  { value: "RJ", label: "Rio de Janeiro" },
  { value: "RN", label: "Rio Grande do Norte" },
  { value: "RS", label: "Rio Grande do Sul" },
  { value: "RO", label: "Rondônia" },
  { value: "RR", label: "Roraima" },
  { value: "SC", label: "Santa Catarina" },
  { value: "SP", label: "São Paulo" },
  { value: "SE", label: "Sergipe" },
  { value: "TO", label: "Tocantins" }
];

export function validateCPF(cpf) {
  cpf = cpf.replace(/\D/g, "");
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  let sum = 0, rest;
  for (let i = 0; i < 9; i++) sum += parseInt(cpf.charAt(i)) * (10 - i);
  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) rest = 0;
  if (rest !== parseInt(cpf.charAt(9))) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(cpf.charAt(i)) * (11 - i);
  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) rest = 0;

  return rest === parseInt(cpf.charAt(10));
}

export function validateCNPJ(cnpj) {
  cnpj = cnpj.replace(/\D/g, "");
  if (cnpj.length !== 14) return false;

  let size = cnpj.length - 2;
  let numbers = cnpj.substring(0, size);
  let digits = cnpj.substring(size);
  let sum = 0;
  let pos = size - 7;

  for (let i = size; i >= 1; i--) {
    sum += numbers.charAt(size - i) * pos--;
    if (pos < 2) pos = 9;
  }

  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(digits.charAt(0))) return false;

  size = size + 1;
  numbers = cnpj.substring(0, size);
  sum = 0;
  pos = size - 7;

  for (let i = size; i >= 1; i--) {
    sum += numbers.charAt(size - i) * pos--;
    if (pos < 2) pos = 9;
  }

  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  return result === parseInt(digits.charAt(1));
}

export const validateCpfOrCnpj = (value) => {
  const onlyDigits = value.replace(/\D/g, "");

  if (onlyDigits.length === 11) {
    return validateCPF(onlyDigits);
  } else if (onlyDigits.length === 14) {
    return validateCNPJ(onlyDigits);
  }

  return false;
};

export const validatePhone = (value) => {
  if (!value) return false;
  const phone = /^\(\d{2}\) \d{5}-\d{4}$/;
  return phone.test(value);
};

export function formatDocument(value) {
  const numbersOnly = value.replace(/\D/g, "");

  if (numbersOnly.length <= 11) {
    return numbersOnly
      .slice(0, 11)
      .replace(/^(\d{3})(\d)/, "$1.$2")
      .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
  }

  return numbersOnly
    .slice(0, 14)
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4")
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, "$1.$2.$3/$4-$5");
}

export function formatCEP(value) {
  const numbersOnly = value.replace(/\D/g, "").slice(0, 8);
  return numbersOnly.replace(/^(\d{5})(\d{3})$/, "$1-$2");
}

export async function fetchAddressByCEP(cep, setAddress) {
  try {
    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
    const data = await response.json();

    if (!data.erro) {
      if (setAddress) {
        setAddress((prev) => ({
          ...prev,
          logradouro: data.logradouro || "",
          bairro: data.bairro || "",
          localidade: data.localidade || "",
          uf: data.uf || "",
        }));
      }
      return data;
    }
  } catch (error) {
    console.error("Error searching for CEP", error);
  }
}

export function formatPhoneNumber(value) {
  if (!value) return "";

  const cleaned = value.replace(/\D/g, "");

  if (cleaned.length <= 2) return cleaned;
  if (cleaned.length <= 6) return cleaned.replace(/^(\d{2})(\d{0,4})/, "($1) $2");
  if (cleaned.length <= 10) return cleaned.replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");

  return cleaned.replace(/^(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3");
}

export function validateEmail(value) {
  if (!value || value.trim() === "") { return true; }
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(value);
}

export function validateTime(value) {
  if (!value || value.trim() === "") { return true; }
  const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
  return timeRegex.test(value);
}

export function getEmptyPageResponse({ pageSize = DEFAULT_PAGE_SIZE } = {}) {
  return {
    size: pageSize,
    number: 0,
    total_pages: 0,
    total_elements: 0,
    content: [],
  };
}

export function toQueryFilters(params) {
  return `busca=${params.term || ""}&pagina=${params.pagina || 1}&limite=${params.pageSize || DEFAULT_PAGE_SIZE}`;
}

export function toSearchFilter(params) {
  return {
    "busca": params.term,
    "filtros": params.filters,
    "pagina": params.page || 1,
    "limite": params.pageSize || DEFAULT_PAGE_SIZE,
    "campo_ordenacao": params.orderBy || DEFAULT_ORDER_FIELD,
    "direcao_ordenacao": params.orderDirection || ASC,
  }
}

export function toTablePageableData(response, { orderBy, orderDirection, defaultField = DEFAULT_ORDER_FIELD, term = undefined }) {
  return {
    pageIndex: response.number,
    pageSize: response.size,
    pageCount: response.total_pages,
    totalElements: response.total_elements,
    orderBy: orderBy ?? defaultField,
    orderDirection: orderDirection,
    term: term,
  };
}

export function parseDateBrToISO(dateStr) {
  if (!dateStr) return null;
  const [day, month, year] = dateStr.split('/');
  return new Date(`${year}-${month}-${day}`);
}

export function parseDateBrToISODateString(dateStr, splitValue = '/', joinValue = '-') {
  if (!dateStr) return null;
  const [day, month, year] = dateStr.split(splitValue);
  if (!day || !month || !year) return null;
  return `${year}${joinValue}${month.padStart(2, "0")}${joinValue}${day.padStart(2, "0")}`;
}

export function formatDate(value, joinValue = "/") {
  if (!value) return "-";

  const date = new Date(value);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return [day, month, year].join(joinValue);
}

export function formatMoney(value) {
  const number = Number(value);
  if (isNaN(number)) {
    return '0,00';
  }

  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(number);
}

export function toTitleCase(value) {
  if (!value) return '';
  return value
    .toLowerCase()
    .split(/[\s_-]+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function isDifferentValue(oldValue, newValue) {
  const isArray = Array.isArray(oldValue) && Array.isArray(newValue);
  if (isArray) {
    const sortedOld = [...oldValue].sort();
    const sortedNew = [...newValue].sort();
    return (
      oldValue.length !== newValue.length ||
      sortedOld.some((val, i) => val !== sortedNew[i])
    );
  }
  return oldValue !== newValue;
}

export function formatCPF(value) {
  return value
    .replace(/\D/g, "")
    .slice(0, 11)
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
}

export function calculateAge(birth_date) {
  if (!birth_date) return null;
  const [day, month, year] = birth_date.split("/").map(Number);
  const today = new Date();
  let age = today.getFullYear() - year;
  const currentMonth = today.getMonth() + 1;
  const currentDay = today.getDate();

  if (currentMonth < month || (currentMonth === month && currentDay < day)) {
    age--;
  }

  return age;
}

export function parseBoolean(value) {
  if (typeof value === "boolean") return value;
  if (typeof value === "string") return value.toLowerCase() === "true";
  return false;
}

export function formatDateInputToDateTimeString(dateStr) {
  return `${dateStr} 00:00:00`;
}

export const formatDateNaturalLanguage = (dateStr, splitter = '/') => {
  if (!dateStr) return null;
  const [day, month, year] = dateStr.split(splitter);
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  return new Intl.DateTimeFormat(LOCALE_PT_BR, {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  }).format(date);
};

export const getDateAndTime = (dateStr, splitter = ' ') => {
  if (!dateStr) return null;
  const [date, time] = dateStr.split(splitter);
  return { date: date, time: time }
}

export function removeNonDigits(value) {
  return value.replace(/\D/g, '');
}

export const maskDate = (value) => {
  let v = value.replace(/\D/g, "");
  if (v.length > 2) v = v.slice(0, 2) + "/" + v.slice(2);
  if (v.length > 5) v = v.slice(0, 5) + "/" + v.slice(5, 9);
  return v.slice(0, 10);
};

export const isoToBrFormat = (isoDate) => {
  if (!isoDate) return '';
  const [year, month, day] = isoDate.split('-');
  return `${day}/${month}/${year}`;
};

export const iso8601ToBrFormat = isoDate => {
  if (!isoDate) return '';
  const [year, month, day] = isoDate.substring(0,10).split('-');
  return `${day}/${month}/${year}`;
}

export const brToIsoFormat = (brDate) => {
  if (!brDate) return '';
  const [day, month, year] = brDate.split('/');
  return `${year}-${month}-${day}`;
};

export const base64ToFile = (base64Data, filenameWithoutExt= "file") => {
  const match = base64Data.match(/^data:(.*);base64,/);
  if (!match) throw new Error("Base64 inválido");

  const mimeType = match[1];
  const extension = mimeType.split('/')[1];

  const bstr = atob(base64Data.split(",")[1]);
  const n = bstr.length;
  const u8arr = new Uint8Array(n);
  for (let i = 0; i < n; i++) {
    u8arr[i] = bstr.charCodeAt(i);
  }

  const filename = `${filenameWithoutExt}.${extension}`;
  return new File([u8arr], filename, {type: mimeType});
};